import React, { Component } from 'react';
import axios from 'axios';
import Modal from 'react-awesome-modal';

class PokeDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chosenPokemon: {
                name: 'pikachu',
                baseExp: '',
                height: '',
                weight: '',
            },
            visible: false,
        }    
    }

    openModal() {
        this.setState({
            visible: true
        });
    }

    closeModal() {
        this.setState({
            visible: false
        });
    }
    //Axios call to get the pokemon details
    async fetchChosenPokemonDetails(){
        try {
            const pokeDetails = await axios.get(`https://pokeapi.co/api/v2/pokemon/${this.props.selectedPokemon}/`)

            this.setState ({
                chosenPokemon: {
                    name: pokeDetails.data.name,
                    baseExp: pokeDetails.data.base_experience,
                    height: pokeDetails.data.height,
                    weight: pokeDetails.data.weight,
                }
            })
            this.openModal();
        } catch (error) {
            console.log(error.message);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.selectedPokemon && this.props.selectedPokemon !== prevProps.selectedPokemon){
            this.fetchChosenPokemonDetails();
        }
    }

    renderEmptyState() {
        return (
            <div><p>Pls click on a pokemon in order to see details</p></div>
        )
    }

    render() {
        return (
            <section>
                <Modal
                    visible={this.state.visible}
                    width="290"
                    effect="fadeInUp"
                    onClickAway={() => this.closeModal()}
                >
                    <div className="pokeDetailsContainer">
                        <h2>Pokemon Details</h2>
                        <div className="pokeDetailsContents">
                            <h3>{this.state.chosenPokemon.name}</h3>
                            <img className="pokeDetailsImage" src={`http://pokestadium.com/sprites/xy/${this.state.chosenPokemon.name}.gif`} alt={this.state.chosenPokemon.name} />
                            <ul className="pokeDetails"> 
                                <li> Base Experience: {this.state.chosenPokemon.baseExp}</li>
                                <li>Height: {this.state.chosenPokemon.height}</li>
                                <li>Weight: {this.state.chosenPokemon.weight}</li>
                            </ul>
                        </div>
                        <a className="closeButton" href="#!" onClick={() => this.closeModal()}>Close</a>
                    </div>
                </Modal>
            </section>
        );
    }
}
export default PokeDetail;